import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Mail, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", {
        email,
        origin_url: window.location.origin,
      });
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Une erreur est survenue");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-100px)] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md" data-testid="forgot-password-page">
        <div className="w-12 h-12 rounded-full bg-[#C86B5E]/10 flex items-center justify-center mb-6">
          <Mail className="w-5 h-5 text-[#C86B5E]" strokeWidth={1.5} />
        </div>
        <h1 className="font-heading text-3xl sm:text-4xl tracking-tight mb-3">
          Mot de passe oublié ?
        </h1>
        {sent ? (
          <div data-testid="forgot-password-success">
            <p className="text-[#5C5754] leading-relaxed mb-8">
              Si un compte existe pour <strong>{email}</strong>, un email contenant un lien de
              réinitialisation vient d'être envoyé. Pense à vérifier tes spams. Le lien est valable
              1 heure.
            </p>
            <Link
              to="/auth?mode=login"
              data-testid="back-to-login"
              className="inline-flex items-center gap-2 text-[#C86B5E] hover:text-[#B35A4E]"
            >
              <ArrowLeft className="w-4 h-4" /> Retour à la connexion
            </Link>
          </div>
        ) : (
          <>
            <p className="text-[#5C5754] leading-relaxed mb-8">
              Saisis ton adresse email : nous t'enverrons un lien pour choisir un nouveau mot de passe.
            </p>
            <form onSubmit={submit} className="space-y-5">
              <div>
                <label className="text-xs tracking-[0.2em] uppercase text-[#5C5754] font-semibold">
                  Email
                </label>
                <input
                  data-testid="forgot-email-input"
                  required
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-2 w-full bg-white border border-[#E6E2DD] focus:border-[#C86B5E] focus:outline-none rounded-xl px-4 py-3.5 text-[#2C2A29] transition-colors"
                  placeholder="tonemail@exemple.com"
                />
              </div>
              <button
                data-testid="forgot-submit-button"
                type="submit"
                disabled={loading}
                className="w-full bg-[#C86B5E] hover:bg-[#B35A4E] disabled:opacity-50 text-white rounded-full px-8 py-4 transition-colors"
              >
                {loading ? "Envoi…" : "Envoyer le lien"}
              </button>
            </form>
            <p className="mt-6 text-center">
              <Link
                to="/auth?mode=login"
                className="text-xs text-[#8A8480] hover:text-[#C86B5E] tracking-wider"
              >
                ← Retour à la connexion
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
